import { api, unwrapData } from 'app/store/api';
import type { CustomerBehaviorAnalytics, CustomerBehaviorAnalyticsPeriod } from '../types/customer-behavior-analytics.types';

export type CustomerBehaviorAnalyticsQueryArgs = {
    gatewayId: number;
    period: CustomerBehaviorAnalyticsPeriod;
    startDate?: string;
    endDate?: string;
};

export const customerBehaviorAnalyticsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        customerBehaviorAnalytics: builder.query<
            CustomerBehaviorAnalytics,
            CustomerBehaviorAnalyticsQueryArgs
        >({
            transformResponse: unwrapData,
            query: ({ gatewayId, period, startDate, endDate }) => ({
                url: `workspaces/${gatewayId}/transactions/customer-behavior`,
                method: 'GET',
                params:
                    period === 'custom' && startDate && endDate
                        ? { start_date: startDate, end_date: endDate }
                        : { period },
            }),
            providesTags: ['Transaction'],
        }),
    }),
});

export const { useCustomerBehaviorAnalyticsQuery } = customerBehaviorAnalyticsApi;
